import { type GetStaticPropsContext } from 'next'
import { prepareGetStaticProps } from '@public/CmsPage/prepareGetStaticProps'
import { CmsConsultationPageBySlugDocument as CMS_CONSULTATION_PAGE_BY_SLUG_QUERY } from 'types/graphql-generated'

interface PrepareGetStaticPropsForConsultationsPageProps {
  slug: string
  route?: string
}

export function prepareGetStaticPropsForConsultationsPage(
  context: GetStaticPropsContext,
  { slug, route }: PrepareGetStaticPropsForConsultationsPageProps
) {
  return prepareGetStaticProps(context, {
    slug,
    query: CMS_CONSULTATION_PAGE_BY_SLUG_QUERY,
    route,
  })
}
